import { useState, useCallback, useEffect } from "react";

// DONNÉES PRODUITS
const PRODUITS = [
  { id: "CLOUD20",  cap: "20 L/jour",   usage: "Maison · Bureau · Studio",           prix: 2490  },
  { id: "CLOUD80",  cap: "80 L/jour",   usage: "Resto · Commerce · Gîte",            prix: 3870  },
  { id: "CLOUD250", cap: "250 L/jour",  usage: "PME · Hôtel · Résidence",            prix: 13104 },
];

const MODES_PAIEMENT = [
  { id: "virement",  icon: "🏛️", label: "Virement bancaire",    desc: "100% à la commande",           tag: "100% virement",      tagColor: "#3a8c3f" },
  { id: "50pct",     icon: "⚖️", label: "50% / 50%",            desc: "50% commande · 50% livraison", tag: "Acompte + solde",    tagColor: "#1565c0" },
  { id: "soguafi",   icon: "🏦", label: "Crédit SOGUAFI",        desc: "Financement bancaire partenaire",tag: "Financement bancaire",tagColor: "#7B5E00" },
  { id: "autre",     icon: "📋", label: "Autre financement",     desc: "Leasing, subvention, institutionnel…", tag: "À préciser", tagColor: "#555" },
];

const TYPES_SITE = [
  "Résidence principale", "Résidence secondaire", "Commerce / Restaurant",
  "Hôtel / Gîte", "Bureau / Entreprise", "Site industriel", "Collectivité", "Autre",
];

const ILES = [
  "Guadeloupe", "Marie-Galante", "Martinique", "La Désirade",
  "Les Saintes", "Saint-Martin", "Saint-Barthélemy", "Autre",
];

// HELPERS
const genRef = () => {
  const d = new Date();
  return `ECO-${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}-${Math.floor(1000+Math.random()*9000)}`;
};

const fmt = (n) => n.toLocaleString("fr-FR") + " €";

// STYLES CSS
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=DM+Mono:wght@400;500;600&display=swap');

.ecl-wrap * { box-sizing: border-box; margin: 0; padding: 0; }
.ecl-wrap {
  font-family: 'Sora', sans-serif;
  background: #f0f4f8;
  color: #1a2b3c;
  min-height: 100vh;
  padding-bottom: 60px;
}
.ecl-title-bar {
  max-width: 860px;
  margin: 0 auto;
  padding: 32px 16px 24px;
  text-align: left;
}
.ecl-title-bar h1 {
  font-size: 26px;
  font-weight: 800;
  color: #1a2b3c;
  letter-spacing: -0.5px;
}
.ecl-title-bar p {
  font-size: 11px;
  color: #3a8c3f;
  font-family: 'DM Mono', monospace;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-top: 6px;
  font-weight: 600;
}
.ecl-recap {
  background:#1a2b3c; border-radius:12px; padding:18px 22px;
  margin-bottom:18px; color:white;
}
.ecl-recap-title {
  font-size:10px; font-weight:600; text-transform:uppercase;
  letter-spacing:2px; color:#00c896; font-family:'DM Mono',monospace;
  margin-bottom:12px;
}
.ecl-recap-line {
  display:flex; justify-content:space-between; align-items:center;
  padding:5px 0; border-bottom:1px solid rgba(255,255,255,.07);
  font-size:13px;
}
.ecl-recap-line:last-child { border-bottom:none; }
.ecl-recap-line .lbl { color:rgba(255,255,255,.55); }
.ecl-recap-total {
  display:flex; justify-content:space-between; align-items:center;
  margin-top:10px; padding-top:12px; border-top:1px solid rgba(255,255,255,.2);
  font-size:18px; font-weight:800;
}
.ecl-recap-total span:last-child { color:#00c896; }
.ecl-recap-empty { color:rgba(255,255,255,.35); font-size:12px; text-align:center; padding:4px 0; }
.ecl-section {
  background:white; border-radius:14px; border:1px solid #d1dce8;
  margin-bottom:18px; overflow:hidden;
  transition: box-shadow .2s;
}
.ecl-section:hover { box-shadow: 0 4px 20px rgba(26,43,60,.07); }
.ecl-section-head {
  background:#1a2b3c; padding:12px 22px;
  display:flex; align-items:center; gap:10px;
}
.ecl-num {
  width:26px; height:26px; background:#3a8c3f; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  color:white; font-size:12px; font-weight:700; flex-shrink:0;
}
.ecl-section-head h2 {
  color:white; font-size:13px; font-weight:700;
  letter-spacing:1px; text-transform:uppercase;
}
.ecl-body { padding:22px; }
.ecl-row { display:grid; gap:14px; margin-bottom:14px; }
.ecl-row.col2 { grid-template-columns:1fr 1fr; }
.ecl-row.col3 { grid-template-columns:1fr 1fr 1fr; }
.ecl-row.col1 { grid-template-columns:1fr; }
.ecl-field label {
  display:block; font-size:10px; font-weight:600;
  text-transform:uppercase; letter-spacing:1px;
  color:#7a8fa6; margin-bottom:5px; font-family:'DM Mono',monospace;
}
.ecl-field input, .ecl-field select, .ecl-field textarea {
  width:100%; padding:10px 13px;
  border:1.5px solid #d1dce8; border-radius:8px;
  font-size:14px; font-family:'Sora',sans-serif;
  color:#1a2b3c; background:#f7fafc; outline:none;
  transition: border-color .2s, box-shadow .2s;
}
.ecl-field input:focus, .ecl-field select:focus, .ecl-field textarea:focus {
  border-color:#3a8c3f; box-shadow:0 0 0 3px rgba(58,140,63,.12);
  background:white;
}
.ecl-field textarea { resize:vertical; min-height:70px; }
.ecl-produits { display:grid; grid-template-columns:repeat(3,1fr); gap:12px; }
.ecl-produit {
  border:2px solid #d1dce8; border-radius:12px; padding:16px 14px;
  cursor:pointer; transition:all .2s; background:#f7fafc; position:relative;
}
.ecl-produit:hover { border-color:#3a8c3f; background:white; }
.ecl-produit.active {
  border-color:#3a8c3f; background:#f0faf0;
  box-shadow:0 0 0 3px rgba(58,140,63,.12);
}
.ecl-prod-model { font-size:18px; font-weight:800; color:#1a2b3c; }
.ecl-prod-model span { color:#3a8c3f; }
.ecl-prod-cap { font-size:11px; color:#7a8fa6; font-family:'DM Mono',monospace; margin:3px 0; }
.ecl-prod-usage { font-size:11px; color:#7a8fa6; margin-bottom:10px; }
.ecl-prod-prix { font-size:20px; font-weight:800; color:#1a2b3c; }
.ecl-prod-prix span { font-size:12px; font-weight:400; color:#7a8fa6; }
.ecl-prod-check {
  position:absolute; top:10px; right:10px;
  width:20px; height:20px; border-radius:50%;
  border:2px solid #d1dce8; display:flex; align-items:center; justify-content:center;
  font-size:10px; color:transparent; transition:all .2s;
}
.ecl-produit.active .ecl-prod-check { background:#3a8c3f; border-color:#3a8c3f; color:white; }
.ecl-qty {
  display:flex; align-items:center; gap:8px; margin-top:10px;
  overflow:hidden; max-height:0; opacity:0; transition:all .2s;
}
.ecl-produit.active .ecl-qty { max-height:40px; opacity:1; }
.ecl-qty label { font-size:10px; color:#7a8fa6; font-family:'DM Mono',monospace; font-weight:600; }
.ecl-qty input {
  width:60px; padding:5px 8px; border:1.5px solid #d1dce8;
  border-radius:6px; font-size:13px; text-align:center;
  font-family:'Sora',sans-serif; background:white;
}
.ecl-pays { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
.ecl-pay {
  border:2px solid #d1dce8; border-radius:12px; padding:16px 16px 12px;
  cursor:pointer; transition:all .2s; background:#f7fafc; position:relative;
}
.ecl-pay:hover { border-color:#3a8c3f; background:white; }
.ecl-pay.active { border-color:#3a8c3f; background:#f0faf0; box-shadow:0 0 0 3px rgba(58,140,63,.12); }
.ecl-pay.gold.active { border-color:#7B5E00; background:#fffbf0; box-shadow:0 0 0 3px rgba(123,94,0,.12); }
.ecl-pay-icon { font-size:24px; margin-bottom:6px; }
.ecl-pay-title { font-size:14px; font-weight:700; color:#1a2b3c; margin-bottom:2px; }
.ecl-pay-desc { font-size:11px; color:#7a8fa6; line-height:1.4; }
.ecl-pay-tag {
  display:inline-block; margin-top:7px; padding:2px 9px; border-radius:100px;
  font-size:9px; font-weight:700; text-transform:uppercase;
  letter-spacing:1px; font-family:'DM Mono',monospace;
}
.ecl-pay-check {
  position:absolute; top:10px; right:10px;
  width:18px; height:18px; border-radius:50%;
  border:2px solid #d1dce8; display:flex; align-items:center; justify-content:center;
  font-size:9px; color:transparent; transition:all .2s;
}
.ecl-pay.active .ecl-pay-check { background:#3a8c3f; border-color:#3a8c3f; color:white; }
.ecl-pay.gold.active .ecl-pay-check { background:#7B5E00; border-color:#7B5E00; color:white; }
.ecl-pay-detail {
  margin-top:14px; padding:14px; border-radius:8px;
  border:1px solid #ffe082; background:#fff8e1;
}
.ecl-pay-detail label {
  display:block; font-size:10px; font-weight:600; text-transform:uppercase;
  letter-spacing:1px; color:#7B5E00; margin-bottom:5px;
  font-family:'DM Mono',monospace;
}
.ecl-pay-detail select, .ecl-pay-detail input {
  width:100%; padding:9px 12px; border:1.5px solid #ffe082;
  border-radius:7px; font-size:13px; font-family:'Sora',sans-serif;
  background:white; margin-bottom:10px; outline:none; color:#1a2b3c;
}
.ecl-pay-detail .note {
  font-size:10px; color:#b8860b; font-family:'DM Mono',monospace; line-height:1.6;
}
.ecl-pay-detail-gray {
  margin-top:14px; padding:14px; border-radius:8px;
  border:1px solid #d1dce8; background:#f7fafc;
}
.ecl-pay-detail-gray label {
  display:block; font-size:10px; font-weight:600; text-transform:uppercase;
  letter-spacing:1px; color:#7a8fa6; margin-bottom:5px;
  font-family:'DM Mono',monospace;
}
.ecl-pay-detail-gray input {
  width:100%; padding:9px 12px; border:1.5px solid #d1dce8;
  border-radius:7px; font-size:13px; font-family:'Sora',sans-serif;
  background:white; outline:none; color:#1a2b3c;
}
.ecl-meta {
  display:flex; justify-content:space-between; align-items:center;
  padding:10px 22px; background:#f7fafc; border-top:1px solid #d1dce8;
  font-size:10px; color:#7a8fa6; font-family:'DM Mono',monospace;
}
.ecl-meta strong { color:#1a2b3c; }
.ecl-cgv {
  display:flex; align-items:flex-start; gap:10px;
  padding:14px; background:#f7fafc; border-radius:8px;
  border:1px solid #d1dce8; margin-bottom:12px;
}
.ecl-cgv input[type="checkbox"] { width:16px; height:16px; margin-top:2px; accent-color:#3a8c3f; flex-shrink:0; cursor:pointer; }
.ecl-cgv label { font-size:12px; color:#7a8fa6; line-height:1.6; cursor:pointer; }
.ecl-cgv label strong { color:#1a2b3c; }
.ecl-sigs { display:grid; grid-template-columns:1fr 1fr; gap:14px; margin-top:18px; }
.ecl-sig {
  border:1.5px dashed #d1dce8; border-radius:10px; padding:14px;
  text-align:center; min-height:90px;
  display:flex; flex-direction:column; align-items:center; justify-content:center; gap:5px;
}
.ecl-sig .lbl { font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:1px; color:#7a8fa6; font-family:'DM Mono',monospace; }
.ecl-sig .sub { font-size:11px; color:#aab; }
.ecl-submit {
  width:100%; padding:16px; background:#3a8c3f; color:white;
  border:none; border-radius:12px; font-size:15px; font-weight:700;
  font-family:'Sora',sans-serif; cursor:pointer; transition:all .2s;
  margin-top:14px; letter-spacing:.3px;
}
.ecl-submit:hover { background:#2d7a32; transform:translateY(-1px); box-shadow:0 8px 24px rgba(58,140,63,.3); }
.ecl-submit:active { transform:translateY(0); }
.ecl-submit:disabled { background:#a5d6a7; cursor:not-allowed; transform:none; box-shadow:none; }
.ecl-submit-note { text-align:center; font-size:10px; color:#7a8fa6; margin-top:10px; font-family:'DM Mono',monospace; }
.ecl-error {
  background:#ffebee; border:1px solid #ef9a9a; color:#c62828;
  padding:12px 16px; border-radius:8px; font-size:13px; margin-bottom:12px;
}
.ecl-success {
  background:#e8f5e9; border:1px solid #a5d6a7; color:#2e7d32;
  padding:20px; border-radius:12px; text-align:center; margin-bottom:18px;
}
.ecl-success h3 { font-size:18px; font-weight:800; margin-bottom:6px; }
.ecl-success p { font-size:13px; opacity:.8; }
.ecl-success .ref { font-family:'DM Mono',monospace; font-weight:600; font-size:14px; margin-top:8px; }
.ecl-loading { display:inline-block; width:16px; height:16px; border:2px solid rgba(255,255,255,.4); border-top-color:white; border-radius:50%; animation:ecl-spin .7s linear infinite; margin-right:8px; vertical-align:middle; }
@keyframes ecl-spin { to { transform:rotate(360deg); } }

@media(max-width:640px){
  .ecl-title-bar { padding:24px 16px 16px; }
  .ecl-title-bar h1 { font-size:22px; }
  .ecl-produits { grid-template-columns:1fr; }
  .ecl-pays { grid-template-columns:1fr; }
  .ecl-row.col2, .ecl-row.col3 { grid-template-columns:1fr; }
  .ecl-sigs { grid-template-columns:1fr; }
  .ecl-body { padding:16px; }
}
`;

export default function BulletinCommande({
  apiEndpoint = "/api/commande",
  logoSrc = null,
  onSuccess = null,
  preselectedProduct = null,
  preselectedPaiement = null,
  preselectedDuree = null,
}) {
  const [ref] = useState(genRef);
  const today = new Date().toLocaleDateString("fr-FR", { day:"2-digit", month:"long", year:"numeric" });

  const [form, setForm] = useState({
    civilite: "", nom: "", tel: "", email: "",
    adresse: "", commune: "", cp: "", ile: "Guadeloupe",
  });

  const initialProduits = { CLOUD20: 0, CLOUD80: 0, CLOUD250: 0 };
  if (preselectedProduct && initialProduits.hasOwnProperty(preselectedProduct.toUpperCase())) {
    initialProduits[preselectedProduct.toUpperCase()] = 1;
  }
  const [produits, setProduits] = useState(initialProduits);

  const validPaiements = ["virement", "50pct", "soguafi", "autre"];
  const initialPaiement = {
    mode: validPaiements.includes(preselectedPaiement) ? preselectedPaiement : "",
    soguafiDuree: preselectedDuree || "",
    soguafiApport: "",
    autrePrecision: "",
  };
  const [paiement, setPaiement] = useState(initialPaiement);

  // Si on arrive avec un mode de paiement présélectionné, on scrolle vers la section paiement
  useEffect(() => {
    if (preselectedPaiement && validPaiements.includes(preselectedPaiement)) {
      const t = setTimeout(() => {
        const el = document.querySelector(`[data-testid="paiement-${preselectedPaiement}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 400);
      return () => clearTimeout(t);
    }
  }, [preselectedPaiement, validPaiements]);
  const [installation, setInstallation] = useState({ adresse: "", typeSite: "", remarques: "" });
  const [commercial, setCommercial] = useState({ nom: "", tel: "" });
  const [cgv, setCgv] = useState(false);
  const [rgpd, setRgpd] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(null);

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setP = (k, v) => setPaiement(p => ({ ...p, [k]: v }));
  const setI = (k, v) => setInstallation(i => ({ ...i, [k]: v }));
  const setC = (k, v) => setCommercial(c => ({ ...c, [k]: v }));

  const toggleProduit = useCallback((id) => {
    setProduits(p => ({ ...p, [id]: p[id] > 0 ? 0 : 1 }));
  }, []);

  const setQty = useCallback((id, val) => {
    const q = Math.max(1, Math.min(99, parseInt(val) || 1));
    setProduits(p => ({ ...p, [id]: q }));
  }, []);

  const lignes = PRODUITS.filter(p => produits[p.id] > 0).map(p => ({
    ...p, qty: produits[p.id], total: p.prix * produits[p.id]
  }));
  const totalHT = lignes.reduce((s, l) => s + l.total, 0);

  const validate = () => {
    if (!form.nom.trim())      return "Merci de renseigner le nom du client.";
    if (!form.tel.trim())      return "Merci de renseigner un téléphone.";
    if (lignes.length === 0)   return "Merci de sélectionner au moins un produit.";
    if (!paiement.mode)        return "Merci de choisir un mode de règlement.";
    if (!cgv)                  return "Merci d'accepter les conditions générales de vente.";
    return null;
  };

  const buildPayload = () => ({
    reference: ref,
    date: new Date().toISOString(),
    client: { ...form },
    commande: lignes.map(l => ({ modele: l.id, quantite: l.qty, prixUnitaireHT: l.prix, totalHT: l.total })),
    totalHT,
    paiement: {
      mode: paiement.mode,
      ...(paiement.mode === "soguafi" && {
        soguafiDuree: paiement.soguafiDuree,
        soguafiApport: paiement.soguafiApport,
      }),
      ...(paiement.mode === "autre" && { autrePrecision: paiement.autrePrecision }),
    },
    installation: { ...installation },
    commercial: { ...commercial },
    cgv: true,
    rgpd,
  });

  const handleSubmit = async () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError("");
    setLoading(true);

    const payload = buildPayload();

    try {
      const res = await fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || `Erreur ${res.status}`);
      }

      setSuccess({ ref, payload });
      if (onSuccess) onSuccess(ref, payload);
    } catch (e) {
      setError("Erreur lors de l'envoi : " + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="ecl-wrap" data-testid="bulletin-commande">

        {/* TITRE */}
        <div className="ecl-title-bar">
          <h1>Bulletin de commande</h1>
          <p>Gamme CLOUD · Solutions d'autonomie en eau</p>
        </div>

        <div style={{ maxWidth: 860, margin: "0 auto", padding: "0 16px 28px" }}>

          {/* SUCCES */}
          {success && (
            <div className="ecl-success" data-testid="commande-success">
              <h3>Commande enregistrée !</h3>
              <p>Un conseiller ECOCLIMA vous contactera sous 24h pour confirmer les prochaines étapes.</p>
              <div className="ref">Réf. {success.ref}</div>
            </div>
          )}

          {/* RECAP */}
          <div className="ecl-recap">
            <div className="ecl-recap-title">Récapitulatif de commande</div>
            {lignes.length === 0
              ? <div className="ecl-recap-empty">Sélectionnez un produit pour voir le récapitulatif</div>
              : <>
                  {lignes.map(l => (
                    <div className="ecl-recap-line" key={l.id}>
                      <span className="lbl">{l.id} × {l.qty}</span>
                      <span style={{ fontWeight: 600 }}>{fmt(l.total)}</span>
                    </div>
                  ))}
                  <div className="ecl-recap-total">
                    <span>TOTAL HT</span>
                    <span>{fmt(totalHT)}</span>
                  </div>
                </>
            }
          </div>

          {/* 1. COORDONNEES */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">1</div>
              <h2>Coordonnées du client</h2>
            </div>
            <div className="ecl-body">
              <div className="ecl-row col2">
                <div className="ecl-field">
                  <label>Civilité</label>
                  <select value={form.civilite} onChange={e => setF("civilite", e.target.value)}>
                    <option value="">-- Choisir --</option>
                    <option>M.</option><option>Mme</option><option>Société</option>
                  </select>
                </div>
                <div className="ecl-field">
                  <label>Nom & Prénom / Raison sociale *</label>
                  <input value={form.nom} onChange={e => setF("nom", e.target.value)} placeholder="Ex : Jean MARTIN" />
                </div>
              </div>
              <div className="ecl-row col2">
                <div className="ecl-field">
                  <label>Téléphone *</label>
                  <input type="tel" value={form.tel} onChange={e => setF("tel", e.target.value)} placeholder="0690 XX XX XX" />
                </div>
                <div className="ecl-field">
                  <label>Email</label>
                  <input type="email" value={form.email} onChange={e => setF("email", e.target.value)} placeholder="jean@example.com" />
                </div>
              </div>
              <div className="ecl-row col1">
                <div className="ecl-field">
                  <label>Adresse complète</label>
                  <input value={form.adresse} onChange={e => setF("adresse", e.target.value)} placeholder="N°, rue, quartier" />
                </div>
              </div>
              <div className="ecl-row col3">
                <div className="ecl-field">
                  <label>Commune</label>
                  <input value={form.commune} onChange={e => setF("commune", e.target.value)} placeholder="Baie-Mahault" />
                </div>
                <div className="ecl-field">
                  <label>Code postal</label>
                  <input value={form.cp} onChange={e => setF("cp", e.target.value)} placeholder="971XX" />
                </div>
                <div className="ecl-field">
                  <label>Île / Territoire</label>
                  <select value={form.ile} onChange={e => setF("ile", e.target.value)}>
                    {ILES.map(i => <option key={i}>{i}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="ecl-meta">
              <span>Référence : <strong>{ref}</strong></span>
              <span>Date : <strong>{today}</strong></span>
            </div>
          </div>

          {/* 2. PRODUITS */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">2</div>
              <h2>Équipement(s) commandé(s)</h2>
            </div>
            <div className="ecl-body">
              <div className="ecl-produits">
                {PRODUITS.map(p => (
                  <div
                    key={p.id}
                    className={`ecl-produit${produits[p.id] > 0 ? " active" : ""}`}
                    onClick={() => toggleProduit(p.id)}
                    data-testid={`produit-${p.id}`}
                  >
                    <div className="ecl-prod-check">✓</div>
                    <div className="ecl-prod-model">
                      {p.id.replace(/(\d+)/, "")}
                      <span>{p.id.match(/\d+/)[0]}</span>
                    </div>
                    <div className="ecl-prod-cap">{p.cap}</div>
                    <div className="ecl-prod-usage">{p.usage}</div>
                    <div className="ecl-prod-prix">{fmt(p.prix)}<span> HT</span></div>
                    <div className="ecl-qty" onClick={e => e.stopPropagation()}>
                      <label>Qté</label>
                      <input
                        type="number" min="1" max="99"
                        value={produits[p.id] || 1}
                        onChange={e => setQty(p.id, e.target.value)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 3. PAIEMENT */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">3</div>
              <h2>Mode de règlement</h2>
            </div>
            <div className="ecl-body">
              <div className="ecl-pays">
                {MODES_PAIEMENT.map(m => (
                  <div
                    key={m.id}
                    className={`ecl-pay${m.id === "soguafi" ? " gold" : ""}${paiement.mode === m.id ? " active" : ""}`}
                    onClick={() => setP("mode", m.id)}
                    data-testid={`paiement-${m.id}`}
                  >
                    <div className="ecl-pay-check">✓</div>
                    <div className="ecl-pay-icon">{m.icon}</div>
                    <div className="ecl-pay-title">{m.label}</div>
                    <div className="ecl-pay-desc">{m.desc}</div>
                    <span className="ecl-pay-tag" style={{ background: m.tagColor + "22", color: m.tagColor }}>
                      {m.tag}
                    </span>
                  </div>
                ))}
              </div>

              {paiement.mode === "soguafi" && (
                <div className="ecl-pay-detail">
                  <label>Durée du crédit souhaitée</label>
                  <select value={paiement.soguafiDuree} onChange={e => setP("soguafiDuree", e.target.value)}>
                    <option value="">-- Choisir --</option>
                    {["12 mois","24 mois","36 mois","48 mois","60 mois"].map(d => <option key={d}>{d}</option>)}
                  </select>
                  <label>Apport personnel (si souhaité)</label>
                  <input
                    value={paiement.soguafiApport}
                    onChange={e => setP("soguafiApport", e.target.value)}
                    placeholder="Ex : 500 €"
                    style={{ marginBottom: 8 }}
                  />
                  <div className="note">ℹ️ Dossier SOGUAFI constitué et transmis par ECOCLIMA. Accord sous réserve d'acceptation.</div>
                </div>
              )}

              {paiement.mode === "autre" && (
                <div className="ecl-pay-detail-gray">
                  <label>Préciser le mode de financement</label>
                  <input
                    value={paiement.autrePrecision}
                    onChange={e => setP("autrePrecision", e.target.value)}
                    placeholder="Ex : Leasing 36 mois, subvention ADEME..."
                  />
                </div>
              )}
            </div>
          </div>

          {/* 4. INSTALLATION */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">4</div>
              <h2>Informations d'installation</h2>
            </div>
            <div className="ecl-body">
              <div className="ecl-row col1">
                <div className="ecl-field">
                  <label>Adresse d'installation (si différente de l'adresse client)</label>
                  <input value={installation.adresse} onChange={e => setI("adresse", e.target.value)} placeholder="Laisser vide si identique" />
                </div>
              </div>
              <div className="ecl-row col1">
                <div className="ecl-field">
                  <label>Type de site</label>
                  <select value={installation.typeSite} onChange={e => setI("typeSite", e.target.value)}>
                    <option value="">-- Choisir --</option>
                    {TYPES_SITE.map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div className="ecl-row col1">
                <div className="ecl-field">
                  <label>Remarques / Informations complémentaires</label>
                  <textarea
                    value={installation.remarques}
                    onChange={e => setI("remarques", e.target.value)}
                    placeholder="Contraintes d'accès, configuration du site..."
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 5. COMMERCIAL */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">5</div>
              <h2>Commercial référent</h2>
            </div>
            <div className="ecl-body">
              <div className="ecl-row col2">
                <div className="ecl-field">
                  <label>Nom du commercial</label>
                  <input value={commercial.nom} onChange={e => setC("nom", e.target.value)} placeholder="Prénom NOM" />
                </div>
                <div className="ecl-field">
                  <label>Téléphone</label>
                  <input type="tel" value={commercial.tel} onChange={e => setC("tel", e.target.value)} placeholder="0690 XX XX XX" />
                </div>
              </div>
            </div>
          </div>

          {/* 6. ENGAGEMENT */}
          <div className="ecl-section">
            <div className="ecl-section-head">
              <div className="ecl-num">6</div>
              <h2>Engagement & Signature</h2>
            </div>
            <div className="ecl-body">
              {error && <div className="ecl-error" data-testid="commande-error">{error}</div>}

              <div className="ecl-cgv">
                <input type="checkbox" id="ecl-cgv" checked={cgv} onChange={e => setCgv(e.target.checked)} />
                <label htmlFor="ecl-cgv">
                  J'ai pris connaissance et j'accepte les <strong>Conditions Générales de Vente</strong> d'ECOCLIMA.
                  Je confirme que les informations renseignées sont exactes et valide la présente commande.
                </label>
              </div>

              <div className="ecl-cgv">
                <input type="checkbox" id="ecl-rgpd" checked={rgpd} onChange={e => setRgpd(e.target.checked)} />
                <label htmlFor="ecl-rgpd">
                  J'accepte que mes données soient utilisées par <strong>ECOCLIMA</strong> dans le cadre du traitement de ma commande, conformément au RGPD.
                </label>
              </div>

              <button
                className="ecl-submit"
                onClick={handleSubmit}
                disabled={loading || !!success}
                data-testid="submit-commande"
              >
                {loading && <span className="ecl-loading" />}
                {loading ? "Envoi en cours..." : success ? "Commande envoyée" : "Valider le bulletin de commande"}
              </button>

              <p className="ecl-submit-note">
                Document confidentiel – ECOCLIMA © 2025
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
